import { Component } from '@angular/core';
import { RevealDirective } from '../../../directives/reveal.directive';

@Component({
  selector: 'app-how-it-works',
  standalone: true,
  imports: [RevealDirective],
  templateUrl: './how-it-works.component.html',
})
export class HowItWorksComponent {}
